import { CoreEnums } from '@/utils/domain/constants';

/**
 * Current-action filter for GET processInstance/requests/{source}/{status?}.
 * Values are the numeric ActionType enum. Labels stay on
 * `applications.text.actionType{n}`. Empty selection must stay undefined so
 * the request omits `actionTypes` entirely.
 *
 * Numeric values are sent instead of enum member names: the API accepts both,
 * and two frontend keys (`FTPOperation`, `SendSMS`) do not match the API names.
 */
export function normalizeActionTypes(value) {
  if (value == null || value === '') return undefined;

  const list = Array.isArray(value) ? value : [value];
  const normalized = [];

  list.forEach((item) => {
    const raw = item && typeof item === 'object' && 'value' in item ? item.value : item;
    if (raw === undefined || raw === null || raw === '') return;
    normalized.push(raw);
  });

  return normalized.length ? normalized : undefined;
}

export function partitionRequestFilters(globalFilters) {
  const { actionTypes, ...odataFilters } = globalFilters || {};
  return {
    odataFilters,
    actionTypes: normalizeActionTypes(actionTypes),
  };
}

export function buildActionTypeFilterOptions() {
  return Object.keys(CoreEnums.ActionType)
    .map((key) => ({
      value: CoreEnums.ActionType[key],
      label: `applications.text.actionType${CoreEnums.ActionType[key]}`,
    }))
    .sort((a, b) => a.value - b.value);
}
